import React, {useEffect} from 'react'
import {makeStyles} from "@material-ui/core/styles";
import LoginLogoutsMainView from "./LoginLogoutsMainView";

const useStyles = makeStyles(theme => ({

}));


export interface iMeta {
    id?: number,
    descricao: string,
    ano: number,
    mes: number,
    diasUteis?: number,
    metaCategoriaId: number,
    estabelecimentoId: number,
    turno: number,
    objetivo: number
}


const LoginLogouts = ( props   ) => {
    const classes = useStyles();

    return (
        <React.Fragment>
            <LoginLogoutsMainView />
        </React.Fragment>
    )
}

export default  (LoginLogouts);

